import React from 'react';
import LegalPage from '../components/LegalPage';

const Terms = () => (
  <LegalPage
    title="Terms of Service"
    description="The terms that govern your use of AVbot, the free Web3 Discord bot."
    file="terms.md"
  />
);

export default Terms;
